exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index_products_1GhgU {\n  width: 1200px;\n  margin: 0 auto;\n}\n\n.index_products_1GhgU .index_productContent_2omWu {\n  margin-top: 12px;\n  clear: both;\n}\n\n.index_products_1GhgU .index_productContent_2omWu:after {\n  content: \"\";\n  clear: both;\n  height: 0;\n  width: 0;\n  visibility: hidden;\n  display: block;\n}\n", ""]);

// Exports
exports.locals = {
	"products": "index_products_1GhgU",
	"productContent": "index_productContent_2omWu"
};